<template>
  <el-col :span="24">
    <el-col :span="20" style="text-align: right;margin-top: 20px;margin-bottom: 20px;">
      <ComponentDatePicker ref="ComponentDatePicker"></ComponentDatePicker>
    </el-col>
    <el-col :span="4" style="text-align: center;margin-top: 20px;margin-bottom: 20px;">
      <el-button type="danger" @click="ostentation_time">按时间查询排场</el-button>
      <el-button type="danger" @click="daochu">导出</el-button>
    </el-col>
    <el-table :data="
      tableData.filter(
        (data) =>
          !search || data.name.toLowerCase().includes(search.toLowerCase())
      )
    " border style="width: 100%">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <!-- <el-table-column label="序号" prop="id"> </el-table-column> -->
      <el-table-column label="日期" prop="time_start">
        <template slot-scope="scope">
          {{ret_YearMonthDate(scope.row.time_start)}}
        </template>
      </el-table-column>
      <el-table-column label="时间" prop="time_end">
        <template slot-scope="scope">
          {{ret_YearMonthDateHoursMin(scope.row.time_start)}} ~ {{ret_YearMonthDateHoursMin(scope.row.time_end)}}
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="phone"></el-table-column>
      <el-table-column label="人数" width="50" align="center" prop="people_count"> </el-table-column>
      <el-table-column label="游戏名称" prop="game_id">
        <template slot-scope="scope">
          {{game_name(scope.row.game_id).name}}
        </template>
      </el-table-column>

      <el-table-column label="陪玩人数" prop="play_with_count">
        <template slot-scope="scope">
          {{scope.row.play_with_count}}
        </template>
      </el-table-column>
      <el-table-column label="付费" prop="aftert_pay_status">
        <template slot-scope="scope">
          {{scope.row.aftert_pay_status==1?"后付费":"先付费"}}
        </template>
      </el-table-column>

      <el-table-column label="厅位" prop="hall_type">
        <template slot-scope="scope">
          {{scope.row.hall_type}}号厅
        </template>
      </el-table-column>
      <el-table-column label="用户来源" prop="people_source">
        <template slot-scope="scope">
          {{user_source.find(item => item.value==scope.row.people_source).label}}
        </template>
      </el-table-column>
      <el-table-column label="陪玩人数" prop="play_with_count">
        <template slot-scope="scope">
          {{scope.row.play_with_count}}
        </template>
      </el-table-column>
      <el-table-column label="付款方式" prop="payment_mode">
        <template slot-scope="scope">
          {{payment_method_agent.find(item => item.value==scope.row.payment_mode).label}}
        </template>
      </el-table-column>
      <el-table-column label="原价金额" prop="turnover">
        <template slot-scope="scope">
          {{scope.row.turnover}}
        </template>
      </el-table-column>
      <el-table-column label="实收金额" prop="net_receipts">
        <template slot-scope="scope">
          {{scope.row.net_receipts}}
        </template>
      </el-table-column>
      <el-table-column label="订单号" prop="payment_serial_number">
        <template slot-scope="scope">
          {{scope.row.payment_serial_number}}
        </template>
      </el-table-column>
      <el-table-column label="服务人员" prop="waiter">
        <template slot-scope="scope">
          {{scope.row.waiter}}
        </template>
      </el-table-column>
      <!--      <el-table-column label="其他平台流水号/券码"  prop="thrid_party_code">
        <template slot-scope="scope">
          {{scope.row.thrid_party_code}}
        </template>
      </el-table-column> -->
      <el-table-column label="是否线下转线上" prop="offline_conversion">
        <template slot-scope="scope">
          {{scope.row.offline_conversion==1?'是':'否'}}
        </template>
      </el-table-column>
      <el-table-column label="私域" prop="private_domain">
        <template slot-scope="scope">
          {{scope.row.private_domain==1?'是':'否'}}
        </template>
      </el-table-column>
      <!--      <el-table-column label="短信发送" prop="sms_status">
        <template slot-scope="scope">
          {{scope.row.sms_status==0?'未发送':'已发送'}}
        </template>
      </el-table-column>
      <el-table-column label="用户须知" prop="signature_status">
        <template slot-scope="scope">
          {{scope.row.signature_status==0?'未填写':'已填写'}}
        </template>
      </el-table-column>
      <el-table-column label="会员注册" prop="registered_memberstatus">
        <template slot-scope="scope">
          {{scope.row.registered_memberstatus==0?'未注册':'已注册'}}
        </template>
      </el-table-column> -->
      <el-table-column label="补差价" prop="extra_money">
        <template slot-scope="scope">
          {{scope.row.extra_money}}
        </template>
      </el-table-column>
      <el-table-column label="补差价类型" prop="extra_money_type">
        <template slot-scope="scope">
          {{scope.row.extra_money_type==1?"支付宝":"微信"}}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remarks">
        <template slot-scope="scope">
          {{scope.row.remarks}}
        </template>
      </el-table-column>
    </el-table>
  </el-col>
</template>

<script>
  import {
    protocol_ZgrShopOstentation_list_history
  } from '@/assets/js/network/request'
  import {
    gUtilityTime
  } from '@/assets/js/utility/UtiltiyTime'
  import {
    gGameData
  } from '@/assets/js/data/GameData'
  import {
    gUtilityExcel
  } from "@/assets/js/utility/UtilityExcel";
  import payment_methodagent from "@/assets/js/payment_methodagent.json";
  import ComponentDatePicker from "@/components/ComponentDatePicker";
  import {
    gAccount
  } from '@/assets/js/data/Account'
  export default {
    components: {
      ComponentDatePicker
    },
    data() {
      return {
        tableData: [],
        search: '',
        user_source: [{
          value: 1,
          label: '线下路过',
        }, {
          value: 2,
          label: '电话预定'
        }, {
          value: 3,
          label: '业务招待'
        }, {
          value: 4,
          label: '线上预订-大众点评/美团'
        }, {
          value: 5,
          label: '线上团购-大众点评/美团'
        }, {
          value: 6,
          label: '线上预订-口碑团购'
        }, {
          value: 7,
          label: '线上预订-b站'
        }, {
          value: 8,
          label: '线上预订-猫眼'
        }, {
          value: 9,
          label: '线上预订-抖音'
        }, {
          value: 10,
          label: '微盟'
        }, {
          value: 11,
          label: '其他'
        }, {
          value: 12,
          label: '私域'
        }, {
          value: 13,
          label: '小程序'
        }],
        payment_method_agent: [],
      }
    },
    methods: {
      game_name(id) {
        return gGameData.getDataByIDFromAllGameData(id)
      },
      ret_YearMonthDate(time) {
        return gUtilityTime.YearMonthDate(time, 1) + gUtilityTime.YearMonthDate(time, 2) + gUtilityTime.YearMonthDate(
          time, 3)
      },
      ret_YearMonthDateHoursMin(time) {
        return gUtilityTime.YearMonthDate(time, 4) + gUtilityTime.YearMonthDate(time, 5)
      },
      ostentation_time() {
        this.init(gUtilityTime.startTime(this.$refs.ComponentDatePicker.get_time_start()) / 1000, gUtilityTime.endTime(
          this.$refs.ComponentDatePicker.get_time_end()) / 1000)
      },
      daochu() {
        //let title="序号ID,日期,时间,手机号,人数,游戏名称,厅位,用户来源,付款方式,原价金额,实收金额,第三方卷码,是否线下转线上,短信发送,用户须知,会员注册,银豹订单号,备注\n";
        let title = "序号ID,日期,时间,手机号,人数,游戏名称,厅位,用户来源,付款方式,原价金额,实收金额,是否线下转线上,订单号,服务人员,补差价,补差价类型,备注,私域\n";
        let data = [];
        for (let i = 0; i < this.tableData.length; i++) {
          let obj = Object();
          obj.index = (i + 1);
          obj.time_start = this.ret_YearMonthDate(this.tableData[i].time_start);
          obj.time_start1 = this.ret_YearMonthDateHoursMin(this.tableData[i].time_start) + "~" + this
            .ret_YearMonthDateHoursMin(this.tableData[i].time_end);
          obj.phone = this.tableData[i].phone;
          obj.people_count = this.tableData[i].people_count;
          obj.game_id = this.game_name(this.tableData[i].game_id).name;
          obj.hall_type = this.tableData[i].hall_type + "号厅";
          obj.people_source = this.user_source.find(item => item.value == this.tableData[i].people_source).label;
          obj.payment_mode = this.payment_method_agent.find(item => item.value == this.tableData[i].payment_mode).label;
          obj.turnover = this.tableData[i].turnover;
          obj.net_receipts = this.tableData[i].net_receipts;
          obj.offline_conversion = this.tableData[i].offline_conversion == 1 ? '是' : '否';
          obj.payment_serial_number = this.tableData[i].payment_serial_number;
          //obj.thrid_party_code=this.tableData[i].thrid_party_code;

          // obj.sms_status=this.tableData[i].sms_status==0?'未发送':'已发送';
          // obj.signature_status=this.tableData[i].signature_status==0?'未填写':'已填写';
          // obj.registered_memberstatus=this.tableData[i].registered_memberstatus==0?'未注册':'已注册';

          obj.waiter = this.tableData[i].waiter;
          obj.extra_money = this.tableData[i].extra_money;
          obj.extra_money_type = this.tableData[i].extra_money_type == 1 ? "支付宝" : "微信";

          obj.remarks = this.tableData[i].remarks.trim();
          obj.private_domain = this.tableData[i].private_domain == 1 ? '是' : '否';
          data.push(obj)
        }
        gUtilityExcel.download_excel("历史排场数据.xls", title, data)
      },
      init(time_start, time_end) {
        let _this = this;
        let date = new Date();
        if (time_start == undefined) {
          time_start = gUtilityTime.YesterDay((date.getTime()) - (1000 * 60 * 60 * 24), 1);
          time_end = gUtilityTime.YesterDay((date.getTime()) - (1000 * 60 * 60 * 24), 2);
        }
        protocol_ZgrShopOstentation_list_history(time_start, time_end).then(res => {
          _this.tableData = res.ret;
        })
      }
    },
    mounted() {
      this.payment_method_agent = payment_methodagent;
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/PaiChangHistory.vue